import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class DraggablePortal extends React.Component {
  portal = document.getElementById(this.props.selector);

  render() {
    return ReactDOM.createPortal(this.props.children, this.portal);
  }
}

DraggablePortal.propTypes = {
  selector: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

DraggablePortal.defaultProps = {
  selector: 'app',
};

export { DraggablePortal };



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/DraggablePortal.js